import { render, staticRenderFns } from "./HEATMAP_CURRENCY.vue?vue&type=template&id=56a8187d&scoped=true"
import script from "./HEATMAP_CURRENCY.vue?vue&type=script&lang=js"
export * from "./HEATMAP_CURRENCY.vue?vue&type=script&lang=js"
import style0 from "./HEATMAP_CURRENCY.vue?vue&type=style&index=0&id=56a8187d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8187d",
  null
  
)

export default component.exports